import React, { useEffect, useState } from 'react';


import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {styled} from "@mui/material/styles";
import {
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Checkbox,
    ListItemText,
    Button,
    Box
} from '@mui/material';

const DynamicMultiSelectDropdown = ({clearAll,
                                // selectedValues, setSelectedValues,
                                selectorDataPointId, selectorLabel }) => {
    //     const GuildMultiSelect = () => {
    const [checkboxValues, setCheckboxValues] = useState([]);
    const [selectedValues, setSelectedValues] = useState([]);


    const fetchDataPointValues = () =>
        getAllDataPointValues()

            .then(data => {
                console.log("Data Point Values fetched")
                console.log(data);
                setCheckboxValues(data.filter(data => data.dataPointId ===  selectorDataPointId));
            });

    useEffect(() => {
        console.log("This triggers gathering the data point values...");
        fetchDataPointValues();
    }, []);

    const handleChange = (event) => {
        setSelectedValues(event.target.value);
        console.log("Selected Value");
        console.log(event.target.value);
    };

    const handleSelectAll = (event) => {
        event.stopPropagation();
        setSelectedValues(checkboxValues.map(value => value.name));
    };

    const handleClearAll = (event) => {
        event.stopPropagation();
        setSelectedValues([]);
    };

    useEffect(() => {
        console.log("All values cleared.");
        // handleClearAll();
        setSelectedValues([]);
    }, [clearAll]);

    const handleClearField = () => {
        setSelectedValues([]);
        console.log("Values Cleared");
    };

    const NarrowMenu = styled('div')(({ theme }) => ({
        '& .MuiPaper-root': {
            width: 200, // Adjust this value to your desired dropdown menu width
        },
    }));

    return (
        <FormControl sx={{   width: 900}} >
            <InputLabel id="value-multi-select-label"  onClick={handleClearField} >{selectorLabel}</InputLabel>

            <Select
                labelId="value-multi-select-label"
                multiple
                value={selectedValues}
                onChange={handleChange}
                renderValue={(selected) => selected.join(', ')}
                variant="standard"
                MenuProps={{
                    style: {
                        maxWidth: 400,
                    },
                }}
            >
                <MenuItem disableRipple>
                    <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                        <Button size="small" onClick={handleSelectAll}>
                            Select All
                        </Button>

                        <Button size="small" onClick={handleClearAll}>
                            Clear All
                        </Button>
                    </Box>
                </MenuItem>

                {checkboxValues.map((value) => (
                    <MenuItem key={value.id} value={value.name}
                              sx={{
                        minHeight: 12,
                        py: 0,
                    }}>
                        <Checkbox checked={selectedValues.indexOf(value.name) > -1} />
                        <ListItemText primary={value.name} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default DynamicMultiSelectDropdown;
